module.exports = __webpack_public_path__ + "img/duration.73200b33.svg";